<template>
  <div class="lp-quiz" :class="{ 'is-submitted': submitted }">

    <!-- HEADER com progresso -->
    <header class="lp-header">
      <img src="@/assets/imagens/logo-leportini.png" alt="Leportini Cosméticos" class="lp-logo" />
      <div v-if="!submitted" class="lp-progress-wrap">
        <div class="lp-progress">
          <div class="lp-progress-bar" :style="{ width: progressPercent + '%' }"></div>
        </div>
        <span class="lp-progress-label">{{ progressPercent }}%</span>
      </div>
    </header>

    <transition :name="transitionName" mode="out-in">

      <!-- TELA DE SUCESSO -->
      <div v-if="submitted" key="success" class="lp-screen lp-success">
        <div class="lp-success-icon"></div>
        <h2>Seu Protocolo está pronto!</h2>
        <p>Geramos sua rotina capilar exclusiva com base nas suas respostas.</p>
        <a :href="whatsappUrl" target="_blank" class="lp-btn-wpp">
          <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Acessar meu Protocolo no WhatsApp
        </a>
      </div>

      <!-- PERGUNTA ATIVA -->
      <div v-else-if="currentQuestion" :key="currentQuestion.id" class="lp-screen">

        <!-- MENSAGEM MOTIVACIONAL NO INÍCIO -->
        <div v-if="currentStepIndex === 0" class="lp-welcome-banner">
          <p class="lp-welcome-text">Não falta muito para concluir!  Responda algumas perguntas rápidas e descubra sua rotina capilar perfeita.</p>
        </div>

        <!-- TIPO: PICTURE CHOICE -->
        <div v-if="currentQuestion.type === 'picture'" class="lp-q-wrap">
          <p v-if="dynamicTagline" class="lp-tagline">{{ dynamicTagline }}</p>
          <h2 class="lp-title">{{ dynamicTitle }}</h2>
          <div class="lp-picture-grid" :class="'cols-' + currentQuestion.options.length">
            <button
              v-for="opt in currentQuestion.options"
              :key="opt.value"
              class="lp-picture-btn"
              :class="{ selected: answers[currentQuestion.id] === opt.value }"
              @click="selectAndAdvance(currentQuestion.id, opt.value)"
              type="button"
            >
              <img :src="opt.imageSrc" :alt="opt.imageAlt" loading="lazy" />
              <span>{{ opt.label }}</span>
            </button>
          </div>
        </div>

        <!-- TIPO: CHOICE (texto, simples ou múltiplo) -->
        <div v-else-if="currentQuestion.type === 'choice'" class="lp-q-wrap">
          <p v-if="dynamicTagline" class="lp-tagline">{{ dynamicTagline }}</p>
          <h2 class="lp-title">{{ dynamicTitle }}</h2>
          <p v-if="currentQuestion.helpText" class="lp-help">{{ currentQuestion.helpText }}</p>
          <p v-if="currentQuestion.multiple" class="lp-help lp-help-multi">Pode selecionar mais de uma opção</p>
          <div class="lp-choice-list">
            <button
              v-for="opt in currentQuestion.options"
              :key="opt.value"
              class="lp-choice-btn"
              :class="{ selected: isSelected(currentQuestion.id, opt.value) }"
              @click="toggleChoice(currentQuestion.id, opt.value, currentQuestion.multiple)"
              type="button"
            >
              <span class="lp-choice-indicator">
                <span v-if="isSelected(currentQuestion.id, opt.value)"></span>
              </span>
              {{ opt.label }}
            </button>
          </div>
          <button
            v-if="currentQuestion.multiple"
            class="lp-btn-next"
            :disabled="!hasAnswer(currentQuestion.id)"
            @click="advance()"
            type="button"
          >
            Continuar 
          </button>
        </div>

        <!-- TIPO: TERMO DE USO -->
        <div v-else-if="currentQuestion.type === 'termo'" class="lp-q-wrap">
          <h2 class="lp-title">Pronto para receber seu diagnóstico! </h2>
          <p class="lp-help">Clique em enviar para receber seu protocolo capilar personalizado.</p>
          <label class="lp-termo-label">
            <input type="checkbox" v-model="termoAceito" class="lp-termo-check" />
            <span>Li e concordo com a
              <a href="https://loja.leportini.com.br/pagina/privacidade-e-termos-de-uso.html" target="_blank">
                Política de Privacidade
              </a>
            </span>
          </label>
          <p v-if="sendError" class="lp-error">{{ sendError }}</p>
          <button
            class="lp-btn-submit"
            :disabled="!termoAceito || sending"
            @click="onSendData"
            type="button"
          >
            {{ sending ? 'Enviando...' : 'Enviar meu Diagnóstico ' }}
          </button>
        </div>

        <!-- TIPO: TEXT / EMAIL / PHONE / DATE / LONGTEXT -->
        <div v-else class="lp-q-wrap">
          <p v-if="dynamicTagline" class="lp-tagline">{{ dynamicTagline }}</p>
          <h2 class="lp-title">{{ dynamicTitle }}</h2>
          <p v-if="currentQuestion.helpText" class="lp-help">{{ currentQuestion.helpText }}</p>

          <!-- EMAIL -->
          <input
            v-if="currentQuestion.type === 'email'"
            ref="inputRef"
            type="email"
            autocomplete="email"
            inputmode="email"
            class="lp-input"
            :placeholder="currentQuestion.placeholder || 'seu@email.com'"
            :value="answers[currentQuestion.id] || ''"
            @input="onInput(currentQuestion.id, $event.target.value)"
            @keydown.enter.prevent="tryAdvance"
          />

          <!-- PHONE -->
          <div v-else-if="currentQuestion.type === 'phone'" class="lp-phone-wrap">
            <input
              ref="inputRef"
              type="tel"
              autocomplete="tel"
              inputmode="numeric"
              class="lp-input"
              placeholder="(XX) XXXXX-XXXX"
              :value="phoneDisplay"
              @input="onPhoneInput($event.target.value)"
              @keypress="onPhoneKeypress($event)"
              @paste="onPhonePaste($event)"
              @keydown.enter.prevent="tryAdvance"
            />
            <!-- Botões apenas se escolheu Email (opcional) -->
            <div v-if="answers.respostaDiagnostico === 'Por E-mail'" class="lp-optional-actions">
              <button
                class="lp-btn-skip"
                @click="skipWhatsApp()"
                type="button"
              >
                Pular 
              </button>
              <button
                class="lp-btn-add-whatsapp"
                :disabled="!answers.tel || answers.tel.length < 14"
                @click="advance()"
                type="button"
              >
                OK
              </button>
            </div>
            <!-- Se escolheu WhatsApp, não mostra botão (comportamento automático com Enter) -->
          </div>

          <!-- PHONE OPCIONAL (REMOVIDO - agora usa apenas phone acima) -->

          <!-- DATE nativo - resolve bug de data de uma vez por todas -->
          <input
            v-else-if="currentQuestion.type === 'date'"
            ref="inputRef"
            type="date"
            autocomplete="bday"
            class="lp-input lp-input-date"
            :max="todayISO"
            min="1900-01-01"
            :value="answers[currentQuestion.id] || ''"
            @input="onInput(currentQuestion.id, $event.target.value)"
            @keydown.enter.prevent="tryAdvance"
          />

          <!-- BIRTHDAY: Dia + Mes + Ano com selects (opcional) -->
          <div v-else-if="currentQuestion.type === 'birthday'" class="lp-birthday-wrap">
            <div class="lp-birthday-selects">
              <select
                class="lp-select-birthday"
                :value="birthdayDay"
                @change="onBirthdayChange('day', $event.target.value)"
              >
                <option value="" disabled>Dia</option>
                <option v-for="d in 31" :key="'d'+d" :value="String(d).padStart(2,'0')">{{ d }}</option>
              </select>

              <select
                class="lp-select-birthday"
                :value="birthdayMonth"
                @change="onBirthdayChange('month', $event.target.value)"
              >
                <option value="" disabled>Mês</option>
                <option value="01">Janeiro</option>
                <option value="02">Fevereiro</option>
                <option value="03">Março</option>
                <option value="04">Abril</option>
                <option value="05">Maio</option>
                <option value="06">Junho</option>
                <option value="07">Julho</option>
                <option value="08">Agosto</option>
                <option value="09">Setembro</option>
                <option value="10">Outubro</option>
                <option value="11">Novembro</option>
                <option value="12">Dezembro</option>
              </select>

              <select
                class="lp-select-birthday"
                :value="birthdayYear"
                @change="onBirthdayChange('year', $event.target.value)"
              >
                <option value="" disabled>Ano</option>
                <option v-for="y in birthdayYearList" :key="'y'+y" :value="String(y)">{{ y }}</option>
              </select>
            </div>

            <div class="lp-optional-actions">
              <button class="lp-btn-skip" @click="skipBirthday()" type="button">Pular ✕</button>
              <button
                class="lp-btn-add-whatsapp"
                :disabled="!birthdayDay || !birthdayMonth || !birthdayYear"
                @click="confirmBirthday()"
                type="button"
              >OK</button>
            </div>
          </div>

          <!-- LONGTEXT -->
          <textarea
            v-else-if="currentQuestion.type === 'longtext'"
            ref="inputRef"
            class="lp-textarea"
            rows="4"
            :placeholder="currentQuestion.placeholder || ''"
            :value="answers[currentQuestion.id] || ''"
            @input="onInput(currentQuestion.id, $event.target.value)"
            @keydown.enter.exact.prevent="tryAdvance"
          ></textarea>

          <!-- TEXT padrão (nome) -->
          <input
            v-else
            ref="inputRef"
            type="text"
            :autocomplete="currentQuestion.autocomplete || 'on'"
            class="lp-input"
            :placeholder="currentQuestion.placeholder || ''"
            :value="answers[currentQuestion.id] || ''"
            @input="onInput(currentQuestion.id, $event.target.value)"
            @keydown.enter.prevent="tryAdvance"
          />

          <p v-if="fieldError" class="lp-error">{{ fieldError }}</p>

          <div class="lp-btn-row">
            <button class="lp-btn-next" @click="tryAdvance" type="button">
              OK <kbd>ENTER </kbd>
            </button>
          </div>
        </div>

        <!-- Botão Voltar -->
        <button
          v-if="currentStepIndex > 0"
          class="lp-btn-back"
          @click="goBack"
          type="button"
        >
           Voltar
        </button>

      </div>
    </transition>

  </div>
</template>

<script>
import '@/assets/css/diagnostico-form.css'

export default {
  name: 'DiagnosticoForm',

  data() {
    return {
      // --- Estado do formulário ---
      currentStepIndex: 0,
      transitionName: 'slide-left',
      answers: {},
      fieldError: '',
      termoAceito: false,
      submitted: false,
      sending: false,
      sendError: '',
      phoneDisplay: '',

      // --- Rastreamento ---
      sessionId: this.generateSessionId(),
      stepStartTime: Date.now(),
      // Birthday opcional - controles separados (resolve bug do input type=date no mobile)
      birthdayDay: '',
      birthdayMonth: '',
      birthdayYear: '',
      trackingUrl: 'https://nwebhook.leportini.com.br/webhook/form-tracking-43fffbf1-262e-4b93-8857-7a441f0747e1',


      // --- Definição das perguntas ---
      questions: [
        {
          id: 'sexo',
          type: 'picture',
          tagline: 'Encontrar a rotina de cuidados perfeita para o seu cabelo é essencial. Um cabelo bonito começa com um bom diagnóstico, vamos começar! 😊',
          title: 'Você é?',
          options: [
            { value: 'F', label: 'Uma Mulher', imageSrc: require('@/assets/imagens/mulher.webp'), imageAlt: 'mulher' },
            { value: 'M', label: 'Um Homem',   imageSrc: require('@/assets/imagens/homem.webp'),  imageAlt: 'homem'  }
          ]
        },
        {
          id: 'nome',
          type: 'text',
          autocomplete: 'given-name',
          tagline: { F: 'Nós gostaríamos de conhecê-la. ', M: 'Nós gostaríamos de conhecê-lo. ' },
          title: 'Qual é o seu nome?',
          placeholder: 'Digite seu nome aqui...',
          required: true
        },
        {
          id: 'perguntaIntencionalDor',
          type: 'longtext',
          title: 'O que mais te incomoda no seu cabelo hoje e você gostaria de mudar?',
          placeholder: 'Ex: ressecamento, frizz, queda, volume, oleosidade...',
          required: true
        },
        {
          id: 'tipoCabelo',
          type: 'choice',
          multiple: false,
          title: 'Qual é o tipo do seu cabelo?',
          helpText: 'Escolha a opção que melhor descreve a condição geral do seu cabelo.',
          options: [
            { value: '1: Secos',   label: 'Secos' },
            { value: '2: Oleosos', label: 'Oleosos' },
            { value: '3: Mistos',  label: 'Mistos â raiz oleosa e pontas secas' }
          ]
        },
        {
          id: 'estruturaDosFios',
          type: 'choice',
          multiple: false,
          title: 'Como você descreveria a estrutura dos seus fios?',
          helpText: 'Selecione a opção que melhor corresponde à condição atual.',
          options: [
            { value: '1: Natural',               label: 'Natural' },
            { value: '2: Ressecados e Sem Brilho', label: 'Ressecados, sem brilho' },
            { value: '3: Danificados (Quebradiços)', label: 'Danificados, quebradiços' }
          ]
        },
        {
          id: 'curvatura',
          type: 'picture',
          tagline: 'Selecione a opção que melhor representa a curvatura dos seus cabelos.',
          title: 'Curvatura dos fios:',
          options: [
            { value: '1: Liso',     label: 'Liso',     imageSrc: require('@/assets/imagens/cabelo-liso.webp'),     imageAlt: 'liso' },
            { value: '2: Ondulado', label: 'Ondulado', imageSrc: require('@/assets/imagens/cabelo-ondulado.webp'), imageAlt: 'ondulado' },
            { value: '3: Cacheado', label: 'Cacheado', imageSrc: require('@/assets/imagens/cabelo-cacheado.webp'), imageAlt: 'cacheado' },
            { value: '4: Crespo',   label: 'Crespo',   imageSrc: require('@/assets/imagens/cabelo-crespo.webp'),   imageAlt: 'crespo' }
          ]
        },
        {
          id: 'texturaDosFios',
          type: 'picture',
          tagline: 'Selecione a opção que melhor representa a espessura dos seus fios.',
          title: 'Textura dos fios:',
          options: [
            { value: '1: Fino',   label: 'Finos',   imageSrc: require('@/assets/imagens/fio-fino.jpg'),   imageAlt: 'fino' },
            { value: '2: Médio',  label: 'Médios',  imageSrc: require('@/assets/imagens/fio-medio.jpg'),  imageAlt: 'médio' },
            { value: '3: Grosso', label: 'Grossos', imageSrc: require('@/assets/imagens/fio-grosso.jpg'), imageAlt: 'grosso' }
          ]
        },
        {
          id: 'elasticidadeDosFios',
          type: 'choice',
          multiple: false,
          title: 'Elasticidade dos fios:',
          helpText: 'Estique um fio molhado â o que acontece?',
          options: [
            { value: '1: Boa Elasticidade',  label: 'Estica e volta ao normal' },
            { value: '2: Sem Elasticidade',  label: 'Estica mas não volta' },
            { value: '3: Fios Quebradiços',  label: 'Parte quando esticado' }
          ]
        },
        {
          id: 'processosQuimicos',
          type: 'choice',
          multiple: true,
          title: 'Quais processos químicos você costuma fazer?',
          helpText: 'Quais procedimentos químicos são habitualmente aplicados em seus cabelos:',
          options: [
            { value: '1: Descoloração (Mechas, Luzes)', label: 'Descoloração, mechas, luzes' },
            { value: '2: Coloração',   label: 'Coloração' },
            { value: '3: Progressiva', label: 'Progressiva' },
            { value: '4: Selagem',     label: 'Selagem' },
            { value: '5: Relaxamento', label: 'Relaxamento' },
            { value: '6: Nenhum',      label: 'Nenhum' }
          ]
        },
        {
          id: 'lavaCabelo',
          type: 'choice',
          multiple: false,
          title: 'Com que frequência você lava o cabelo?',
          options: [
            { value: '1: Todos os Dias',        label: 'Todos os dias' },
            { value: '2: Uma Vez por Semana',   label: 'Uma vez por semana' },
            { value: '3: Dia Sim, Dia Não',     label: 'Dia sim, dia não' }
          ]
        },
        {
          id: 'couroCabeludo',
          type: 'choice',
          multiple: false,
          title: 'Seu couro cabeludo apresenta algum desses sinais?',
          options: [
            { value: '1: Caspa',    label: 'Caspa' },
            { value: '2: Seborreia', label: 'Seborreia (oleosidade excessiva)' },
            { value: '3: Queda',    label: 'Queda' },
            { value: '4: Não Apresenta Nenhum Desses Sinais', label: 'Nenhum desses sinais' }
          ]
        },
        {
          id: 'secaCabelo',
          type: 'choice',
          multiple: false,
          title: 'Como você geralmente seca o cabelo?',
          options: [
            { value: '1: Secam Naturalmente',    label: 'Ao ar livre, naturalmente' },
            { value: '2: Com Secador',           label: 'Secador' },
            { value: '3: Com Secador e Chapinha', label: 'Secador e chapinha' }
          ]
        },
        {
          id: 'aniversario',
          type: 'birthday',
          tagline: 'Sua idade influencia diretamente nas necessidades do seu cabelo.',
          title: 'Qual é a sua data de nascimento?',
          required: false
        },
        {
          id: 'perguntaIntencionalDesejo',
          type: 'longtext',
          title: 'Se seu cabelo ficasse do jeito que te faz se sentir incrível, como ele seria?',
          placeholder: 'Ex: hidratado e com volume controlado...',
          required: true
        },
        {
          id: 'email',
          type: 'email',
          tagline: { F: 'placeholder', M: 'placeholder' }, // Será computado dinamicamente
          title: 'Informe seu melhor e-mail para receber seu Protocolo Capilar personalizado.',
          placeholder: 'Digite aqui o seu melhor e-mail...',
          required: true
        },
        {
          id: 'respostaDiagnostico',
          type: 'picture',
          tagline: 'Recomendamos receber pelo WhatsApp para resultado imediato.',
          title: 'Como prefere receber seu Protocolo Capilar?',
          options: [
            { value: 'Por WhatsApp', label: 'WhatsApp (Recomendado)', imageSrc: require('@/assets/imagens/whatsApp.png'), imageAlt: 'WhatsApp' },
            { value: 'Por E-mail',   label: 'E-mail (pode demorar)',  imageSrc: require('@/assets/imagens/email.png'),    imageAlt: 'Email' }
          ]
        },
        {
          id: 'tel',
          type: 'phone',
          title: 'Qual é o seu WhatsApp?',
          placeholder: '(XX) XXXXX-XXXX',
          required: (answers) => answers.respostaDiagnostico === 'Por WhatsApp',
          showIf: (answers) => answers.respostaDiagnostico === 'Por WhatsApp' || answers.respostaDiagnostico === 'Por E-mail'
        },
        {
          id: 'termoUso',
          type: 'termo'
        }
      ]
    }
  },

  computed: {
    // Dev mode: desativa tracking quando acesso vem de ?dev=true
    isDevMode() {
      const params = new URLSearchParams(window.location.search)
      return (
        params.get('dev') === 'true' ||
        sessionStorage.getItem('lp_dev_mode') === 'true'
      )
    },

    // Filtra perguntas baseado em showIf
    visibleQuestions() {
      return this.questions.filter(q => {
        if (typeof q.showIf === 'function') return q.showIf(this.answers)
        return true
      })
    },

    currentQuestion() {
      return this.visibleQuestions[this.currentStepIndex] || null
    },

    progressPercent() {
      if (!this.visibleQuestions.length) return 0
      return Math.round(((this.currentStepIndex) / (this.visibleQuestions.length - 1)) * 100)
    },

    todayISO() {
      return new Date().toISOString().split('T')[0]
    },

    // Lista de anos para select de aniversário (do ano atual até 1920)
    birthdayYearList() {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let y = currentYear; y >= 1920; y--) {
        years.push(y)
      }
      return years
    },

    // Título dinâmico baseado no gênero quando necessário
    dynamicTitle() {
      const q = this.currentQuestion
      if (!q) return ''
      if (typeof q.title === 'object') {
        return q.title[this.answers.sexo] || q.title.F || q.title.M || ''
      }
      return q.title || ''
    },

    dynamicTagline() {
      const q = this.currentQuestion
      if (!q) return ''
      
      const nome = (this.answers.nome || '').trim()
      const sexo = this.answers.sexo
      
      // Tagline especial para primeira pergunta após preencher nome
      if (q.id === 'perguntaIntencionalDor') {
        if (nome && sexo) {
          if (sexo === 'F') {
            return `Prazer em conhecê-la, ${nome}! Vamos continuar:`
          } else {
            return `Prazer em conhecê-lo, ${nome}! Vamos continuar:`
          }
        }
      }
      
      // Tagline especial para pergunta de email (chamar pelo nome)
      if (q.id === 'email') {
        if (nome) {
          return `${nome}, seu cabelo já revelou o que precisa. Agora é hora de ver o resultado.`
        }
        return 'Seu cabelo já revelou o que precisa. Agora é hora de ver o resultado.'
      }
      
      // Tagline especial para pergunta de WhatsApp
      if (q.id === 'tel') {
        if (this.answers.respostaDiagnostico === 'Por WhatsApp') {
          return 'Precisamos do seu WhatsApp para enviar o diagnóstico.'
        } else {
          return 'Podemos enviá-lo também por WhatsApp para você acompanhar melhor!'
        }
      }
      
      if (typeof q.tagline === 'object') {
        return q.tagline[this.answers.sexo] || q.tagline.F || q.tagline.M || ''
      }
      return q.tagline || ''
    },

    // URL do WhatsApp baseada no canal escolhido e se WhatsApp foi preenchido
    whatsappUrl() {
      const numero = '553398460017'
      const canal = this.answers.respostaDiagnostico || ''
      const email = (this.answers.email || '').trim()
      const telefone = (this.answers.tel || '').trim()
      const temWhatsapp = telefone && telefone.length >= 10

      let texto
      
      // Se escolheu Email E NÃO preencheu WhatsApp
      if (canal === 'Por E-mail' && email && !temWhatsapp) {
        // Mensagem com email para rotina personalizada
        texto = `Quero minha rotina capilar personalizada no whatsApp e-mail cadastrado: ${email} (Importante: não altere essa mensagem para que possamos identificar seu diagnóstico)`
      } else if (temWhatsapp) {
        // Se tem WhatsApp preenchido (em qualquer cenário)
        texto = 'Quero acessar meu diagnostico'
      } else {
        // Fallback (raramente acontece)
        texto = 'Quero acessar meu diagnostico'
      }
      
      return `https://api.whatsapp.com/send/?phone=${numero}&text=${encodeURIComponent(texto)}`
    }
  },

  mounted() {
    document.addEventListener('keyup', this.onKeyUp)
    window.addEventListener('beforeunload', this.onBeforeUnload)


    // Flag de modo dev  persiste durante toda a sessão
    const devParams = new URLSearchParams(window.location.search)
    if (devParams.get('dev') === 'true') {
      sessionStorage.setItem('lp_dev_mode', 'true')
      console.log('[DEV MODE] Tracking desativado')
    } else {
      sessionStorage.removeItem('lp_dev_mode')
    }

    // UTM first touch
    const qs = window.location.search || ''
    if (qs) sessionStorage.setItem('lp_last_qs', qs)
    if (qs && !localStorage.getItem('lp_ft_qs')) {
      localStorage.setItem('lp_ft_qs', qs)
      localStorage.setItem('lp_ft_ts', String(Date.now()))
    }

    // Rastreamento: início do formulário
    this.trackEvent('form_start', 0, 'sexo', null)
    this.pushDataLayer('form_start', { step_number: 0, step_name: 'sexo' })
  },

  beforeUnmount() {
    document.removeEventListener('keyup', this.onKeyUp)
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },

  watch: {
    currentStepIndex() {
      // Foco automático no input ao mudar de pergunta
      this.$nextTick(() => {
        const input = this.$refs.inputRef
        if (input) input.focus()
      })
      // Resetar erro ao mudar de pergunta
      this.fieldError = ''
      // Iniciar timer da nova pergunta
      this.stepStartTime = Date.now()
    }
  },

  methods: {
    // --- Navegação ---

    advance() {
      const q = this.currentQuestion
      const timeOnStep = Math.round((Date.now() - this.stepStartTime) / 1000)

      // Rastrear resposta
      this.trackEvent('answer', this.currentStepIndex, q.id, this.answers[q.id], timeOnStep)
      this.pushDataLayer('form_step', {
        step_number: this.currentStepIndex,
        step_name: q.id,
        time_on_step: timeOnStep
      })

      if (this.currentStepIndex < this.visibleQuestions.length - 1) {
        this.transitionName = 'slide-left'
        this.currentStepIndex++
      }
    },

    goBack() {
      if (this.currentStepIndex > 0) {
        this.transitionName = 'slide-right'
        this.currentStepIndex--
      }
    },

    tryAdvance() {
      const q = this.currentQuestion
      if (!q) return

      const val = this.answers[q.id] || ''

      // Validação
      if (q.required && !val) {
        this.fieldError = 'Este campo é obrigatório.'
        return
      }

      if (q.type === 'email' && val && !/^[^@]+@.+[^.]$/.test(val)) {
        this.fieldError = 'Digite um e-mail válido.'
        return
      }

      if (q.type === 'phone') {
        const isWhatsAppRequired = this.answers.respostaDiagnostico === 'Por WhatsApp'
        const phoneDigits = this.phoneDisplay.replace(/\D/g, '')
        
        // Se é obrigatório (escolheu WhatsApp)
        if (isWhatsAppRequired) {
          if (!phoneDigits || phoneDigits.length < 11) {
            this.fieldError = 'Digite o número completo com DDD e o nono dígito. Ex: (33) 98888-7777'
            return
          }
          if (phoneDigits[2] !== '9') {
            this.fieldError = 'O número de celular deve começar com 9 após o DDD. Ex: (33) 98888-7777'
            return
          }
        } else {
          // Se é opcional (escolheu Email, mas decidiu adicionar WhatsApp)
              if (phoneDigits && phoneDigits.length > 0) {
                if (phoneDigits.length < 11) {
                  this.fieldError = 'Digite o número completo com DDD e o nono dígito. Ex: (33) 98888-7777'
                  return
                }
                if (phoneDigits[2] !== '9') {
                  this.fieldError = 'O número de celular deve começar com 9 após o DDD. Ex: (33) 98888-7777'
                  return
                }
                // Salvar normalizado com 55
                const normalized = '55' + phoneDigits
                this.answers = { ...this.answers, tel: normalized }  // ? CORRIGIDO
              }
      }
      }

      if (q.type === 'date' && val) {
        const date = new Date(val)
        if (isNaN(date.getTime()) || val > this.todayISO || val < '1900-01-01') {
          this.fieldError = 'Data inválida.'
          return
        }
      }

      this.fieldError = ''
      this.advance()
    },

    // Picture choice: seleciona e avança automaticamente
    selectAndAdvance(questionId, value) {
      this.answers = { ...this.answers, [questionId]: value }
      this.$nextTick(() => this.advance())
    },

    // Pular a captura de WhatsApp (quando escolheu email)
    skipWhatsApp() {
      // Limpar o campo de telefone
      this.answers = { ...this.answers, tel: '' }
      this.phoneDisplay = ''
      this.fieldError = ''
      this.advance()
    },

    // --- Birthday (opcional) ---

    onBirthdayChange(field, value) {
      if (field === 'day') this.birthdayDay = value
      if (field === 'month') this.birthdayMonth = value
      if (field === 'year') this.birthdayYear = value
      this.fieldError = ''
    },

    skipBirthday() {
      // Lead optou por não informar a data
      this.answers = { ...this.answers, aniversario: '' }
      this.birthdayDay = ''
      this.birthdayMonth = ''
      this.birthdayYear = ''
      this.fieldError = ''
      this.advance()
    },

    confirmBirthday() {
      // Confirmar data preenchida e salvar em formato YYYY-MM-DD
      if (this.birthdayDay && this.birthdayMonth && this.birthdayYear) {
        const aniversario = `${this.birthdayYear}-${this.birthdayMonth}-${this.birthdayDay}`
        this.answers = { ...this.answers, aniversario }
        this.fieldError = ''
        this.advance()
      }
    },

    // --- Inputs ---

    onInput(questionId, value) {
      this.answers = { ...this.answers, [questionId]: value }
      this.fieldError = ''
    },

    // Bloquear letras na digitação
    onPhoneKeypress(e) {
      if (e.key === 'Enter') return
      if (!/[0-9]/.test(e.key)) e.preventDefault()
    },

    // Bloquear colar texto com letras â extrair só dígitos do clipboard
    onPhonePaste(e) {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData).getData('text')
      this.onPhoneInput(text)
    },

    onPhoneInput(raw) {
      // Remover TUDO que não for dígito â letras, símbolos, espaços
      let digits = raw.replace(/\D/g, '')

      // CORREÇÃO DDI: Se o número tem 12 ou 13 dígitos e começa com 55,
      // significa que veio com DDI (+55). Removemos o 55 inicial.
      // Casos tratados:
      // - 5533988367751 (13 díg, DDI+DDD+9+8díg) → remove 55 → 33988367751
      // - 553398836775  (12 díg, DDI+DDD+8díg fixo) → remove 55 → 3398836775
      // ATENÇÃO: NÃO remove se for 11 dígitos (ex: 55999998888 é DDD 55 do RS)
      if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
        digits = digits.substring(2)
      }

      // Limitar a 11 dígitos depois do tratamento de DDI
      digits = digits.substring(0, 11)

      // Formatar visualmente: (XX) XXXXX-XXXX
      let formatted = digits
      if (digits.length > 2)  formatted = '(' + digits.substring(0,2) + ') ' + digits.substring(2)
      if (digits.length > 7)  formatted = '(' + digits.substring(0,2) + ') ' + digits.substring(2,7) + '-' + digits.substring(7)

      // Forçar o input a mostrar apenas dígitos formatados (impede letras de aparecer)
      this.phoneDisplay = formatted
      this.$nextTick(() => {
        const input = this.$refs.inputRef
        if (input && input.value !== formatted) input.value = formatted
      })

      // Salvar normalizado com 55 apenas quando completo (11 dígitos)
      const normalized = digits.length === 11 ? '55' + digits : ''
      this.answers = { ...this.answers, tel: normalized }
      this.fieldError = ''
    },

    onKeyUp(e) {
      if (e.key === 'Enter') {
        const q = this.currentQuestion
        if (!q) return
        if (['text', 'email', 'phone', 'date', 'longtext'].includes(q.type)) {
          this.tryAdvance()
        }
      }
    },

    // Seleção/deselecção de múltipla escolha
    toggleChoice(questionId, value, multiple) {
      if (multiple) {
        const current = Array.isArray(this.answers[questionId]) ? [...this.answers[questionId]] : []
        const idx = current.indexOf(value)
        if (idx >= 0) current.splice(idx, 1)
        else current.push(value)
        this.answers = { ...this.answers, [questionId]: current }
      } else {
        this.answers = { ...this.answers, [questionId]: value }
        this.$nextTick(() => this.advance())
      }
    },

    isSelected(questionId, value) {
      const answer = this.answers[questionId]
      if (Array.isArray(answer)) return answer.includes(value)
      return answer === value
    },

    hasAnswer(questionId) {
      const answer = this.answers[questionId]
      if (Array.isArray(answer)) return answer.length > 0
      return !!answer
    },

    // --- Submit ---

    async onSendData() {
      if (!this.termoAceito) return
      this.sending = true
      this.sendError = ''

      const origem = this.obterOrigemLead()
      const payload = {
        // Campos principais â mantém compatibilidade com N8n existente
        sexo:                     this.answers.sexo || '',
        nomeFeminino:             this.answers.sexo === 'F' ? (this.answers.nome || '') : '',
        nomeMasculino:            this.answers.sexo === 'M' ? (this.answers.nome || '') : '',
        emailFeminino:            this.answers.sexo === 'F' ? (this.answers.email || '') : '',
        emailMasculino:           this.answers.sexo === 'M' ? (this.answers.email || '') : '',
        perguntaIntencionalDor:   this.answers.perguntaIntencionalDor || '',
        tipoCabelo:               this.answers.tipoCabelo || '',
        estruturaDosFios:         this.answers.estruturaDosFios || '',
        curvatura:                this.answers.curvatura || '',
        texturaDosFios:           this.answers.texturaDosFios || '',
        elasticidadeDosFios:      this.answers.elasticidadeDosFios || '',
        processosQuimicos:        this.answers.processosQuimicos || '',
        lavaCabelo:               this.answers.lavaCabelo || '',
        couroCabeludo:            this.answers.couroCabeludo || '',
        secaCabelo:               this.answers.secaCabelo || '',
        aniversario:              this.answers.aniversario || '', // já em YYYY-MM-DD (input type=date)
        perguntaIntencionalDesejo: this.answers.perguntaIntencionalDesejo || '',
        respostaDiagnostico:      this.answers.respostaDiagnostico || 'Por WhatsApp',
        tel:                      this.answers.tel || '',
        termoDeUsoEPolitica:      'on',
        numeroWhatsappEscolhido:  '553398460017',
        urlAtual:                 this.obterUrlAtualComUtms(),
        // UTMs
        origem_lead:    origem.origemLead,
        ft_utm_source:  origem.utm_source,
        ft_utm_medium:  origem.utm_medium,
        ft_utm_campaign: origem.utm_campaign,
        ft_utm_content: origem.utm_content,
        ft_utm_term:    origem.utm_term,
        ft_fbclid:      origem.fbclid,
        ft_gclid:       origem.gclid,
        ft_wbraid:      origem.wbraid,
        ft_gbraid:      origem.gbraid,
        ft_referrer:    origem.referrer,
        ft_landing_path: origem.landingPath,
        ft_landing_url:  origem.landingUrl
      }

      try {
        // Dev mode: não envia para o webhook
        if (this.isDevMode) {
          this.submitted = true
          window.onbeforeunload = null
          console.log(' DEV MODE: Dados não foram enviados para o webhook')
          console.log('Payload que seria enviado:', payload)
          this.sending = false
          return
        }

        const response = await fetch(
          'https://nwebhook.leportini.com.br/webhook/d937d412-9ab9-4154-af3b-f3581ea5',
          { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }
        )

        if (response.ok) {
          this.submitted = true
          window.onbeforeunload = null

          // GTM: concluso com form_complete
          this.pushDataLayer('form_complete', {
            step_number: this.visibleQuestions.length,
            step_name: 'submit',
            time_on_step: 0
          })

          // Meta Pixel: dispara evento 'Lead' para converter ? NOVO
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'Lead',
              form_name: 'diagnostico_capilar',
              session_id: this.sessionId
            })
          }

          // Banco: concluso
          this.trackEvent('complete', this.visibleQuestions.length, 'submit', null)

          // No abre WhatsApp em dev mode
          if (!this.isDevMode) {
            window.open(this.whatsappUrl, '_blank')
          }
        } else {
          this.sendError = 'Erro ao enviar. Tente novamente.'
        }
      } catch (e) {
        this.sendError = 'Erro de conexão. Verifique sua internet.'
      } finally {
        this.sending = false
      }
    },

    // --- Rastreamento ---

    generateSessionId() {
      return 'diag_' + Date.now() + '_' + Math.random().toString(36).substring(2, 9)
    },

    // Camada 1: GTM / GA4
    pushDataLayer(eventName, extra = {}) {
      if (this.isDevMode) return
      if (!window.dataLayer) return
      window.dataLayer.push({
        event: eventName,
        form_name: 'diagnostico_capilar',
        session_id: this.sessionId,
        ...extra
      })
    },

    // Camada 2: banco via N8n (fire and forget â não bloqueia o lead)
    trackEvent(event, stepNumber, questionId, answer, timeOnStepSec = 0) {
      if (this.isDevMode) return // DEV MODE: não grava no banco
      const origem = this.obterOrigemLead()
      const body = {
        session_id:      this.sessionId,
        event,
        step_number:     stepNumber,
        question_id:     questionId,
        time_on_step_ms: timeOnStepSec * 1000,
        utm_source:      origem.utm_source,
        utm_medium:      origem.utm_medium,
        utm_campaign:    origem.utm_campaign,
        created_at:      new Date().toISOString(),
        is_dev_mode:     this.isDevMode
      }
      // Fire and forget â usa sendBeacon quando disponível (funciona no beforeunload)
      if (navigator.sendBeacon) {
        navigator.sendBeacon(this.trackingUrl, JSON.stringify(body))
      } else {
        fetch(this.trackingUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
          keepalive: true
        }).catch(() => {})
      }
    },

    // Rastreia abandono quando o lead fecha a aba
    onBeforeUnload() {
      if (this.submitted) return
      const q = this.currentQuestion
      const timeOnStep = Math.round((Date.now() - this.stepStartTime) / 1000)
      this.trackEvent('abandon', this.currentStepIndex, q?.id || '', null, timeOnStep)
      this.pushDataLayer('form_abandon', {
        last_step: this.currentStepIndex,
        last_question: q?.id || ''
      })
    },

    // --- UTMs ---

    obterUrlAtualComUtms() {
      try {
        const qsNow = window.location.search || ''
        const qsSession = sessionStorage.getItem('lp_last_qs') || ''
        const qsFirst = localStorage.getItem('lp_ft_qs') || ''
        const qs = qsNow || qsSession || qsFirst
        const base = window.location.origin + window.location.pathname
        return qs ? (base + qs) : window.location.href.toString()
      } catch {
        return window.location.href.toString()
      }
    },

    obterOrigemLead() {
      const qsNow = window.location.search || ''
      const qsSession = sessionStorage.getItem('lp_last_qs') || ''
      const qsFirst = localStorage.getItem('lp_ft_qs') || ''
      const qs = qsNow || qsSession || qsFirst || ''
      const params = new URLSearchParams(qs)

      const utm_source   = params.get('utm_source')   || ''
      const utm_medium   = params.get('utm_medium')   || ''
      const utm_campaign = params.get('utm_campaign') || ''
      const utm_content  = params.get('utm_content')  || ''
      const utm_term     = params.get('utm_term')     || ''
      const fbclid       = params.get('fbclid')       || ''
      const gclid        = params.get('gclid')        || ''
      const wbraid       = params.get('wbraid')       || ''
      const gbraid       = params.get('gbraid')       || ''
      const referrer     = document.referrer          || ''
      const landingPath  = window.location.pathname   || ''
      const landingUrl   = window.location.origin + window.location.pathname + (qs || '')

      const source = utm_source.toLowerCase()
      const medium = utm_medium.toLowerCase()
      const ref    = referrer.toLowerCase()
      let origemLead = 'Direto/Desconhecido'

      if (source.includes('meta') || source.includes('facebook') || source.includes('instagram')) {
        origemLead = 'Meta (Facebook/Instagram)'
      } else if (ref.includes('facebook.com') || ref.includes('instagram.com') || ref.includes('l.facebook.com')) {
        origemLead = 'Meta (Facebook/Instagram) - Referrer'
      } else if (source.includes('google') || medium.includes('cpc') || medium.includes('ppc')) {
        origemLead = 'Google Ads'
      } else if (ref.includes('google.') && !ref.includes('googleads')) {
        origemLead = 'Google Orgânico'
      } else if (referrer) {
        origemLead = 'Referência (site externo)'
      }

      return { origemLead, utm_source, utm_medium, utm_campaign, utm_content, utm_term, fbclid, gclid, wbraid, gbraid, referrer, landingPath, landingUrl }
    }
  }
}
</script>
